var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_73",
    "data-name": "Group 73",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.18,
    height: 22.114,
    viewBox: "0 0 19.18 22.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M2.556,5.377a1.07,1.07,0,0,0,1.07,1.07H4.2V19.091a3.525,3.525,0,0,0,3.521,3.522h8.857A3.525,3.525,0,0,0,20.1,19.091V6.447h.571a1.07,1.07,0,1,0,0-2.14H16.921V3.2a2.707,2.707,0,0,0-2.7-2.7H10.074a2.707,2.707,0,0,0-2.7,2.7v1.1H3.626a1.07,1.07,0,0,0-1.07,1.07ZM9.511,3.2a.564.564,0,0,1,.564-.564h4.143a.564.564,0,0,1,.564.564v1.1H9.51V3.2ZM6.337,6.447H17.955V19.091a1.383,1.383,0,0,1-1.381,1.382H7.718a1.383,1.383,0,0,1-1.381-1.382V6.447Z",
    transform: "translate(-2.556 -0.499)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M11.842,21.684a1.07,1.07,0,0,0,1.07-1.07V12.671a1.07,1.07,0,1,0-2.14,0v7.944a1.07,1.07,0,0,0,1.07,1.07Zm5.319,0a1.07,1.07,0,0,0,1.07-1.07V12.671a1.07,1.07,0,1,0-2.14,0v7.944a1.07,1.07,0,0,0,1.07,1.07Z",
    transform: "translate(-4.911 -3.682)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.d4a799d56e95c04fcb9776e41c94d8a3.svg";
export { ForwardRef as ReactComponent };